function AnchorScroll(){

	this.WIDTH = 550;
	this.HEIGHT = 450;
	
	this.$jsPopup = $('.js-popup');

	var self = this;


	this.$jsPopup.on('click', function(event){
		self.action($(this).attr('href'),self);
		return false;
	});

}

AnchorScroll.prototype = {
	action : function(href,G){
		window.open(href,'snswindow','width='+ G.WIDTH +',height='+ G.HEIGHT +',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
	}
};

//インスタンスを生成し即時実行
module.exports = new AnchorScroll();


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/popup.js
 ** module id = 5
 ** module chunks = 5
 **/